import WalletBalance from './wallet-balance';

export default WalletBalance;
